import * as Yup from "yup";

export default Yup.object().shape({
  email: Yup.string()
    .email("Please Enter a Valid Email.")
    .required("An email address is required")
});
